/**
 * The `PageTitle` function is a React component that displays a title within a specific layout
 * structure.
 * @returns A functional component named `PageTitle` is being returned. It renders a `div` element with
 * class name "row column_title" containing a nested `div` with class name "col-md-12" which further
 * contains a `div` with class name "page_title" and an `h2` element displaying the `title` prop passed
 * to the component.
 */
const PageTitle = ({ title }) => {
  return (
    <div className="row column_title">
      <div className="col-md-12">
        <div className="page_title">
          <h2>{title}</h2>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
